import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'img[default]',
  host: {
    '(error)':'updateUrl()',
    '[src]':'src'
   }
})
export class DefaultDirective {
  @Input() src : string;
  @Input() default : string;

  updateUrl() {
    this.src = this.default;
  }
}


// WEBPACK FOOTER //
// ./src/directives/default/default.ts